import React from 'react';
import { WhiteContentWrapper } from '../components/content-wrapper';

import phoneIcon from '../assets/icon/shouji_denglu_icon@3x.png';
import codeIcon from '../assets/icon/yanzheng_denglu_icon@3x.png';
import lockIcon from '../assets/icon/mima_denglu_icon@3x.png';
import {
  FIELD_ICON_LEFT,
  GetVerificationButtonField,
  LightBackgroundField,
} from '../components/input-field';
import { LargePrimaryButton } from '../components/button';
import TitledComponent from '../components/titled-component';
import { Field, propTypes, reduxForm } from 'redux-form';
import {
  cellphoneNumberNormalizer,
  cellphoneNumberValidator, passwordNormalizer,
  required,
  verificationCodeNormalizer,
  verificationCodeValidator,
} from '../validator';
import { css } from 'emotion';
import { resetPassword } from '../actions/user';
import { connect } from 'react-redux';

const GetCodeButton = css`
  width: 160px;
  height: 66px;
  font-size: 28px;
  color: white;
  line-height: 1;
  position: absolute;
  right: 30px;
  bottom: 20px;
`;

const FormWrapper = WhiteContentWrapper.withComponent('form');

class _ResetPasswordForm extends React.Component {
  render() {
    const {
      handleSubmit, pristine, submitting, invalid
    } = this.props;

    return (
      <FormWrapper onSubmit={handleSubmit} style={{ height: '100%', paddingTop: '40px' }}>
        <LightBackgroundField>
          <LightBackgroundField.Label>手机号</LightBackgroundField.Label>
          <Field
            name='cellphone'
            validate={cellphoneNumberValidator}
            normalize={cellphoneNumberNormalizer}
            component={LightBackgroundField.Input}
            type='number'
            pattern='\d*' />
          <LightBackgroundField.Icon src={phoneIcon} style={{ width: '26px', height: '40px' }} />
        </LightBackgroundField>

        <LightBackgroundField>
          <LightBackgroundField.Label>验证码</LightBackgroundField.Label>
          <Field
            name='code'
            validate={verificationCodeValidator}
            normalize={verificationCodeNormalizer}
            component={LightBackgroundField.Input}
            type='number'
            pattern='\d*' />
          <LightBackgroundField.Icon
            src={codeIcon}
            style={{
              width: '35px', height: '40px',
              left: `${FIELD_ICON_LEFT - 6}px`,
            }}
          />
          <Field
            name='cellphone'
            component={GetVerificationButtonField}
            validate={cellphoneNumberValidator}
            className={GetCodeButton}
            scope='reset_password'
          />
        </LightBackgroundField>

        <LightBackgroundField>
          <LightBackgroundField.Label>设置新密码</LightBackgroundField.Label>
          <Field
            name='newPassword'
            validate={required}
            normalize={passwordNormalizer}
            component={LightBackgroundField.Input}
            type='text'
            placeholder='6-12位字母数字组合'
          />
          <LightBackgroundField.Icon src={lockIcon} style={{ width: '34px', height: '40px', left: '31px' }} />
        </LightBackgroundField>

        <LargePrimaryButton
          disabled={invalid || pristine || submitting}
          style={{ marginTop: '100px' }}
        >
          确认登陆
        </LargePrimaryButton>

      </FormWrapper>
    );
  }
}

_ResetPasswordForm.defaultProps = {
};

_ResetPasswordForm.propTypes = {
  ...propTypes,
};

export const RESET_PASSWORD_FORM_NAME = 'reset_password';

const ResetPasswordForm = reduxForm({
  form: RESET_PASSWORD_FORM_NAME, // a unique name for this form
})(_ResetPasswordForm);

class ResetPassword extends TitledComponent {
  onSubmit(e) {
    this.props.dispatch(resetPassword(e.cellphone, e.code, e.newPassword));
  }

  render() {
    return <ResetPasswordForm onSubmit={e => this.onSubmit(e)} />;
  }
}

ResetPassword.defaultProps = {
  title: '忘记密码',
};

export default connect()(ResetPassword);



// WEBPACK FOOTER //
// ./src/scene/reset-password.jsx